export default class FieldWithFloatingPlaceholder {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.field-with-floating-placeholder'), el => {
            new FieldWithFloatingPlaceholder(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        // initial state
        if (!this.isEmptyValue()) {
            this.focusHandler();
        }

        // multiple events listener
        let addEventListeners = (eventsList, handler) => {
            eventsList.split(' ').forEach((eventName) => {
                this.element.addEventListener(eventName, (e) => {
                    handler(e);
                });
            });
        }

        addEventListeners('focus keydown change', () => {
            this.focusHandler();
        });

        this.element.addEventListener('blur', () => {
            this.blurHandler();
        });

        document.addEventListener('alpine:initialized', () => {
            this.element.classList[this.isEmptyValue() ? 'remove' : 'add']('field-with-floating-placeholder--is-focused');
        });
    }

    focusHandler() {
        this.element.classList.add('field-with-floating-placeholder--is-focused');
    }

    blurHandler() {
        if (this.isEmptyValue()) {
            this.element.classList.remove('field-with-floating-placeholder--is-focused');
        }
    }

    isEmptyValue() {
        return this.element.value === ''
    }
}
